import * as React from 'react';
import { DefaultRequestListDataProvider } from './DefaultRequestListDataProvider';
import { RequestListDataProvider } from './RequestListDataProvider';

const Context = React.createContext<RequestListDataProvider>(
	DefaultRequestListDataProvider
);

export interface PluginDataProviderContextProviderProps {
	dataProvider?: RequestListDataProvider;
}

export function PluginDataProviderContextProvider(
	props: React.PropsWithChildren<PluginDataProviderContextProviderProps>
) {
	return (
		<Context.Provider value={props.dataProvider ?? DefaultRequestListDataProvider}>
			{props.children}
		</Context.Provider>
	);
}

export const usePluginDataProviderContext = () => React.useContext(Context);
